import React, { useContext, useEffect, useState } from "react";
import HeaderInner from "./Components/HeaderInner";
import { Accordion, AccordionTab } from "primereact/accordion";
import axios from "./axios";
import { useLocation } from "react-router-dom";
import SpaLoader from "./Components/Loaders/SpaLoader";
import Title from "./new-components/title/Title";
import NewFooter from "./NewFooter";
import { ThemeContext } from "./context/ThemeContext";
import ManualAttachmentsModal from "./Components/ManualAttachmentsModal";
import { useTranslation } from "react-i18next";

const GuestDirectory = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const [guest_directory, setGuest_directory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [header_title, setheader_title] = useState("");
  const lang = sessionStorage.getItem("lang");
  const { theme } = useContext(ThemeContext);
  const [attachmentsModalOpen, setAttachmentsModalOpen] = useState(false);
  const [selectedAttachments, setSelectedAttachments] = useState([]);
  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";

  useEffect(() => {
    setLoading(true);
    const getGuestDirectory = async () => {
      // axios.get(`/648ed77e-da78-4987-9b86-de515659fc2c`).then((res) => {
      axios
        .get(`/${room_uuid}/house-manual`, {
          headers: {
            lang: lang,
          },
        })
        .then((res) => {
          const data = res.data.data;
          setheader_title(data?.title);
          setGuest_directory(data.services);
          console.log("data***", data.guest_directory);
          setLoading(false);
        });
    };
    getGuestDirectory();
  }, []);

  const createDynamicTabs = () => {
    return guest_directory.map((tab, i) => {
      return (
        <AccordionTab key={tab.id} header={tab.name} disabled={tab.disabled}>
          {/* <i class="fa fa-plus" aria-hidden="true"></i> */}
          <div
            className="quill-content"
            dangerouslySetInnerHTML={{
              __html: tab.description?.replace(/&nbsp;/g, " "),
            }}
          />
          {tab.attachments?.length > 0 && (
            <button
              type="button"
              className="reg-btn"
              style={{
                marginBottom: "0",
                minWidth: "auto",
                fontWeight: "500",
                border: "none",
                marginTop: "1rem",
              }}
              onClick={() => {
                setSelectedAttachments(tab.attachments ?? []);
                setAttachmentsModalOpen(true);
              }}
            >
              {t("View Attachments")}
            </button>
          )}
        </AccordionTab>
      );
    });
  };

  return (
    <div className={theme ? "food" : ""}>
      {theme ? (
        <Title title={"House Manual"} />
      ) : (
        <HeaderInner headerName={"House Manual"} />
      )}
      <main className="home-main bg-white back-white pad-top-0 px-4">
        {loading ? (
          <SpaLoader />
        ) : (
          <Accordion expandIcon="fa fa-plus" collapseIcon="fa fa-minus">
            {createDynamicTabs()}
          </Accordion>
        )}
      </main>
      {theme && <NewFooter />}
      <ManualAttachmentsModal
        show={attachmentsModalOpen}
        onHide={() => setAttachmentsModalOpen(false)}
        attachments={selectedAttachments}
        theme={theme}
      />
    </div>
  );
};

export default GuestDirectory;
